<template>
    <form class="c-blog__filters" ref="form" @submit="submitHandler">
        <div class="c-blog__filters__search">
            <label class="c-blog__filters__label" for="article">{{ $t('blog.search.label') }}</label>
            <input ref="article" type="text" name="article" id="article" :value="activeFilters.article ?? ''" :placeholder="$t('blog.search.placeholder')" @input="articleInputHandler">
        </div>

        <Categories :categories="categoriesFilters" :activeFilters="activeFilters" @update:states="updateStates($event)"/>

        <Mrc :mrcFilters="mrcFilters" :activeFilters="activeFilters" @update:states="updateStates($event)"/>

        <div class="c-blog__filters__buttons">
            <button class="c-blog__filters__buttons__submit u-visuallyHidden" role="button" :aria-label="$t('blog.submit.aria')">{{ $t('blog.submit.label') }}</button>
            <button class="c-blog__filters__buttons__clear" role="button" @click="resetHandler" :aria-label="$t('blog.clear.aria')">{{ $t('blog.clear.label') }}</button>
        </div>
    </form>
</template>

<script>
    import { nextTick } from 'vue';

    import Categories from './Categories.vue';
    import Mrc from './Mrc.vue';
    import Chevron from './icons/Chevron.vue';

    export default {
        name: 'Filters',
        components: {
            Categories,
            Mrc,
            Chevron,
        },
        props: {
            categoriesFilters: {
                type: Object,
                default: {}
            },
            mrcFilters: {
                type: Array,
                default: []
            },
            activeFilters: {
                type: Object,
                default: null
            },
        },
        data() {
            return {
                lang: window.Store.app.lang,
                categories: null,
                resetValues: false,
                articleTimeout: null,
            }
        },
        watch: { },
        mounted() { },
        computed: { },
        methods: {
            submitHandler(event){
                event?.preventDefault();

                clearTimeout(this.articleTimeout);
                this.articleTimeout = null;

                const formData = new FormData(this.$refs.form);
                const params = {
                    'category': [],
                    'mrc': [],
                    'article': '',
                }

                for (const p of formData.entries()){
                    if(p[0] === 'article'){
                        params.article = p[1];
                    }
                    else{
                        if(this.activeFilters.mrcs.includes(p[0])){
                            params.mrc.push(p[0]);
                        }
                        else if(this.activeFilters.categories.includes(p[0])){
                            params.category.push(p[0]);
                        }
                    }
                }

                this.$emit('filtersSubmitted', params);
            },
            async resetHandler(event){
                // Reset activeFilters data
                this.activeFilters.categories = [];
                this.activeFilters.mrcs = [];
                this.activeFilters.article = '';

                await this.$nextTick();
                this.submitHandler(event);
            },
            updateStates(states){
                this.submitHandler();
            },
            articleInputHandler(){
                clearTimeout(this.articleTimeout);
                this.articleTimeout = null;

                this.articleTimeout = setTimeout(this.submitHandler, 2000);
            }
        },
    }
</script>